import { render, staticRenderFns } from "./ComplexBackgroundSideNav.vue?vue&type=template&id=5d467f26&scoped=true"
import script from "./ComplexBackgroundSideNav.vue?vue&type=script&lang=ts"
export * from "./ComplexBackgroundSideNav.vue?vue&type=script&lang=ts"
import style0 from "./ComplexBackgroundSideNav.vue?vue&type=style&index=0&id=5d467f26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d467f26",
  null
  
)

export default component.exports